import React, { Component } from "react";
import { connect } from "react-redux";
import { Base } from "zina-dogi-react";
import { CostPackageFilter, CostPackageTable } from "../components";
import * as costpackage from "../redux";

export class CostpackageList extends Component {
    componentDidMount() {
        this.props.getCostpackages();
    }

    render() {
        const { costpackages, pagination, changePage, loading, extraProps } = this.props;
        const base_op = {
            className: "costpackage_list",
            title: "Cost package Management",
            breadcrumbs: [{ name: "Home", rel: "/", icon: "home" }, { name: "Cost Package Management" }],
            extraProps,
            loading
        };
        const costpackageTable_op = {
            list: costpackages,
            pagination: {
                ...pagination,
                changePage
            }
        };
        return (
            <Base {...base_op}>
                <CostPackageFilter onSubmit={this.onFilter} />
                <CostPackageTable {...costpackageTable_op} />
            </Base>
        );
    }

    onFilter = filters => {
        this.props.changeFilters(filters);
    };
}

const mapStateToProps = store => ({
    costpackages: store.costpackage.list,
    loading: store.costpackage.loading,
    loaded: store.costpackage.loaded,
    pagination: store.costpackage.pagination
});

const mapDispatchToProps = dispatch => ({
    getCostpackages: () => dispatch(costpackage.actions.getCostpackages()),
    changePage: page => dispatch(costpackage.actions.changePage(page)),
    changeFilters: filters => dispatch(costpackage.actions.updateFilter(filters))
});

export default connect(mapStateToProps, mapDispatchToProps)(CostpackageList);
